import configStore from "../../stores/ConfigStore";

import { UserRequestInfo } from "./UserRequestInfo";
import { UserSummaryInfo } from "./UserSummaryInfo";

export default class MeDataService {

    /**
     * Get the user summery info of the current user.
     *
     * @static
     * @param {string} eventId
     * @returns {Promise<EventInfo>}
     * @memberof EventsDataService
     */
    public static async getMeAsync(): Promise<UserSummaryInfo> {
        const token = await configStore.getTokenAsync();

        return fetch(`${configStore.hosts.api}/me`, {
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "GET",
        })
        .then(e => e.json())
    }

    public static async patchAsync(user: UserRequestInfo): Promise<UserSummaryInfo> {
        const token = await configStore.getTokenAsync();

        return fetch(`${configStore.hosts.api}/me/${configStore!.me!.id}`, {
            body: JSON.stringify(user),
            credentials: "omit",
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
                "meet-i18n": configStore.me?.locale ?? 'en',
            },
            method: "PATCH",
        })
        .then(e => e.json())
    }
}
